import TagGroupDetailList from './TagGroupDetailList';

export default TagGroupDetailList;
